<script setup>
defineProps({
  label: { type: String, required: true },
  checked: { type: Boolean, default: false },
});

const emit = defineEmits(['toggle']);
</script>

<template>
  <label class="sport-live-tv-filter-option">
    <input type="checkbox" class="sport-live-tv-filter-option__input" :checked="checked" @change="emit('toggle')" />
    <span class="sport-live-tv-filter-option__label">{{ label }}</span>
  </label>
</template>

<style lang="scss" scoped>
.sport-live-tv-filter-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: $black50;
  }

  &__input {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    margin: 0;
    accent-color: $bg-red;
    cursor: pointer;
  }

  &__label {
    overflow: hidden;
    color: $white;
    font-size: 13px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
